// IMPORTANT: The three definitions below must be kept in sync
// anytime this file is modified.

// Values can be removed without a backfill: users may have a removed value saved
// as their home screen, and firestoreDocPreferencesSchema falls back to HOME
// when it reads one. Check for any other persisted uses before removing.

// You might be thinking:
// "this seems unnecessarily complicated... why didn't he use a typescript enum?
// Why is the same thing defined three times? What's going on here?"
//
// Well, this file should change very infrequently (if ever). And, with these
// three definitions this funnily-constructed enum becomes very easy to use
// and has very elegant typing across zod and typescript.

export const MainNavScreens: {
  HOME: "HOME";
  TRANSACTIONS: "TRANSACTIONS";
  BALANCES: "BALANCES";
  CASH_FLOW: "CASH_FLOW";
  BUDGETS: "BUDGETS";
} = {
  HOME: "HOME",
  TRANSACTIONS: "TRANSACTIONS",
  BALANCES: "BALANCES",
  CASH_FLOW: "CASH_FLOW",
  BUDGETS: "BUDGETS",
};

// For use with typescript types.
export type MainNavScreens = keyof typeof MainNavScreens;

// For use with enums in zod schemas (https://zod.dev/?id=zod-enums).
// Must keep this up-to-date with the values defined in MainNavScreen above!
export const MAIN_NAV_SCREEN_VALUES = [
  "HOME",
  "TRANSACTIONS",
  "BALANCES",
  "CASH_FLOW",
  "BUDGETS",
] as const;
